// Module
var code = "<div class=\"barn-switcher\" ng-if=\"barn_switcher.showMenu\"> <ng2-bm-ng-select [items]=\"barn_switcher.barns\" [selected]=\"barn_switcher.selectedBarn\" [multiple]=\"false\" [clearable]=\"false\" [placeholder]=\"'Switch Barns'\" (change-selected)=\"barn_switcher.setBarn($event)\"> </ng2-bm-ng-select> </div> ";
// Exports
module.exports = code;